import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Table, Form, Button, Alert, ProgressBar, Modal } from "react-bootstrap";
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import Utils from "./../../common/Utils";
import DateTimePicker from "react-datetime-picker";
import { UserContext } from "../../common";
import ChoosePlans from "../../components/application/ChoosePlans";

import EvidenceList from "./EvidenceList";

const Evidences = (props) => {
  const initFilter = () => ({
    pp: Utils.perpage,
    user: 0,
    branch: 0,
    type: "jobs-recent",
    fromDt: moment().startOf("year").toDate(),
    toDt: moment().toDate(),
    txt: "",
  });

  const {userData} = useContext(UserContext);

  const [filter, setFilter] = useState(initFilter());
  const [data, setData] = useState({
    loading: false,
    total: 0,
    start: 0,
    records: [],
  });
  const [showEvidences, setShowEvidences] = useState({});

  const getRecordStart = (idx = 0) => {
    return data.start + parseInt(idx) + 1;
  };

  let stout = null;

  const setSearchTxt = (e) => {
    let txt = e.currentTarget.value;
    if (stout != null) {
      window.clearTimeout(stout);
    }
    stout = window.setTimeout(() => {
      setFilter({ ...filter, st: 0, txt: txt });
    }, 1000);
  };

  const addFilters = (start) => {
    let str = [
      `pp=${filter.pp}`,
      `st=${start}`,
      `user=${filter.user}`,
      `branch=${filter.branch}`,
      `fromDt=${moment(filter.fromDt).format().substring(0, 19)}`, //== to keep the timezone out
      `toDt=${moment(filter.toDt).endOf("day").format().substring(0, 19)}`, //== to keep the timezone out
      `txt=${filter.txt}`,
    ];
    return "?" + str.join("&");
  };

  const fetchData = (start = 0) => {
    if (moment(filter.fromDt).isAfter(moment(filter.toDt))) {
      window.alert("Please select dates correctly, TO date cannot be earlier than FROM date.");
      return;
    }
    let url = Utils.apiUrl((filter.type === "tasks" ? "tasks" : "jobs") + "/fetchevidences") + addFilters(start);
    url += filter.type !== "tasks" && filter.type === "jobs-recent" ? "&type=recent" : "&type=archived";
    setData({ ...data, loading: true });
    axios
      .get(url, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setData({
            ...data,
            loading: false,
            start: start,
            total: _.get(res, "data.total", 0),
            records: res.data.evidences,
          });
        } else {
          setData({ ...data, total: 0, start: 0, records: [], loading: false });
        }
      })
      .catch((err) => {
        setData({ ...data, loading: false });
        console.log(err);
      });
  };

  useEffect(fetchData, [filter]);

  const [teamMembers, setTeamMembers] = useState([]);
  const [isSuperUser, setIsSuperUser] = useState(Boolean(userData?.is_super_user));
  const [hasReports, setHasReports] = useState(false);

  const fetchTeamMembers = () => {
    axios
      .get(Utils.apiUrl("reports/fetchmembers"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          const members = _.get(res, "data.teamMembers", []);
          const isSuper = Boolean(_.get(res, "data.is_super_user", false));
          const hasRep = Boolean(_.get(res, "data.has_reports", false));
          setIsSuperUser(isSuper);
          setHasReports(hasRep);
          setTeamMembers(members);
          setFilter((prev) => {
            const selfMember = members.find((m) => m.is_self) || members[0];
            if (!isSuper && !hasRep) {
              return { ...prev, user: selfMember ? selfMember.id : (userData?.id || 0) };
            }
            return prev;
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(fetchTeamMembers, []);

  const showPagination = ({ loading, start, total }) => {
    if (loading || (start === 0 && start + filter.pp >= total)) {
      return <></>;
    } else {
      return (
        <div className="d-flex flex-row-reverse">
          {start + filter.pp >= total && (
            <div className="text-disabled ms-2">
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`} alt="Next" /> Next
            </div>
          )}
          {start + filter.pp < total && (
            <div className="clickable ms-2 text-clickable" onClick={() => fetchData(start + filter.pp)}>
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" /> Next
            </div>
          )}
          {start >= filter.pp && (
            <div className="clickable text-clickable" onClick={() => fetchData(start - filter.pp)}>
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
            </div>
          )}
          {start === 0 && (
            <div className="text-disabled">
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`} alt="Previous" />
            </div>
          )}
        </div>
      );
    }
  };

  let nameChanged = null;
  const setName = (e) => {
    let name = e.currentTarget.value;
    if (nameChanged) window.clearTimeout(nameChanged);
    nameChanged = window.setTimeout(() => {
      setFilter({ ...filter, name: name });
    }, 1000);
  };

  const pageSelect = () => {
    return (
      <select
        className="form-select float-right ms-3"
        style={{ width: "80px" }}
        onChange={(e) => setFilter({ ...filter, pp: parseInt(e.target.value) })}
      >
        {[5, 10, 25, 50, 100].map((p) => (
          <option value={p} selected={filter.pp === p}>
            {p}
          </option>
        ))}
      </select>
    );
  };

  if (!Utils.hasAccess(7)) {
    return (
      <>
        {!userData.is_super_user && <h1 className="alert alert-danger p-5 mt-5">No access!</h1>}
        {userData.is_super_user && <>
            <h1 className="alert alert-danger p-4 mt-4">You current plan is restricted to use this module, please Upgrade!</h1>
            <ChoosePlans onPayment={() => { window.location.reload(); }} />
        </>}
      </>
    );
  }

  return (
    <React.Fragment>
      <div>
        <Row className="mt-4">
          <Col>
            <div className="d-flex">
              <h3 className="mx-2 my-3 title">Evidences</h3>

              <select
                className="select-control from-control-select shadow-cst filters my-auto py-2"
                style={{ height: "fit-content" }}
                value={filter.type}
                onChange={(e) => {
                  setFilter({
                    ...filter,
                    type: e.currentTarget.value,
                  });
                  setData({ ...data, records: [] });
                }}
              >
                <option value="jobs-recent">for Jobs (Recent)</option>
                <option value="jobs-archived">for Jobs(Archived)</option>
                <option value="tasks">for Tasks</option>
              </select>
            </div>
            <Form className="evidences-filters">
              <Row className="g-2 align-items-stretch">
                {isSuperUser && (
                  <Col xs={12} sm={6} xl={2}>
                    <select
                      className="w-100 select-control form-control-select form-select shadow-cst filters"
                      value={filter.branch}
                      onChange={(e) =>
                        setFilter({
                          ...filter,
                          user: 0,
                          branch: e.currentTarget.value,
                        })
                      }
                    >
                      <option value="0">All Branches</option>
                      {_.uniqBy(
                        _.filter(teamMembers, (t) => t.branch_id > 0 && t.branch),
                        "branch_id"
                      ).map((b) => (
                        <option key={b.branch_id} value={b.branch_id}>
                          {b.branch}
                        </option>
                      ))}
                    </select>
                  </Col>
                )}
                <Col xs={12} sm={6} xl={isSuperUser ? 2 : 4}>
                  <select
                    className="w-100 select-control form-control-select form-select shadow-cst filters"
                    value={filter.user}
                    disabled={!isSuperUser && !hasReports}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        user: e.currentTarget.value,
                      })
                    }
                  >
                    {isSuperUser && <option value="0">From Everyone</option>}
                    {hasReports && <option value="0">All Team Members</option>}
                    {(filter.branch === 0 || filter.branch === "0"
                      ? teamMembers
                      : _.filter(teamMembers, (t) => t.branch_id == filter.branch || t.is_self)
                    ).map((tm) => (
                      <option key={tm.id} value={tm.id}>
                        {tm.title ? tm.title + " " : ""}{tm.name}
                      </option>
                    ))}
                  </select>
                </Col>
                <Col xs={12} md={6} xl={3}>
                  <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2 h-100 bg-white px-2 py-2 shadow-cst radius-both">
                    <span className="text-nowrap small text-secondary flex-shrink-0 pt-sm-1">From</span>
                    <div className="flex-grow-1 min-w-0 w-100">
                      <DateTimePicker
                        dayPlaceholder="dd"
                        monthPlaceholder="mm"
                        yearPlaceholder="yyyy"
                        clearIcon={null}
                        format="y-MM-dd"
                        onChange={(v) => setFilter({ ...filter, fromDt: v })}
                        value={filter.fromDt}
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6} xl={3}>
                  <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2 h-100 bg-white px-2 py-2 shadow-cst radius-both">
                    <span className="text-nowrap small text-secondary flex-shrink-0 pt-sm-1">To</span>
                    <div className="flex-grow-1 min-w-0 w-100">
                      <DateTimePicker
                        dayPlaceholder="dd"
                        monthPlaceholder="mm"
                        yearPlaceholder="yyyy"
                        clearIcon={null}
                        format="y-MM-dd"
                        onChange={(v) => setFilter({ ...filter, toDt: v })}
                        value={!_.isNull(filter.toDt) ? filter.toDt : filter.fromDt}
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12} xl={2}>
                  <Button variant="light" className="style1 w-100 shadow-cst h-100 radius-both" onClick={() => setFilter({ ...initFilter(), type: filter.type })}>
                    Clear
                  </Button>
                </Col>
              </Row>
              <Row className="g-2 mt-1">
                <Col xs={12}>
                  <input
                    type="text"
                    className="form-control form-control-select shadow-cst"
                    placeholder={filter.type === "tasks" ? "Search by Task or Evidence" : "Search by Job, Job Category or Evidence"}
                    onKeyUp={setSearchTxt}
                  />
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Card border="light" className="shadow table-section p-sm-0 p-lg-1">
              <Card.Body>
                {data.loading && (
                  <Alert variant="success" className="p-3">
                    <p className="loading-msg">Fetching evidences.. </p>
                    <ProgressBar variant="success" animated now={100} />
                  </Alert>
                )}
                {!data.loading && (
                  <>
                    <div className="d-flex flex-row-reverse">
                      {pageSelect()}
                      {showPagination(data)}
                    </div>
                    <Table striped hover responsive>
                      <thead>
                        <tr>
                          <th className="text-center">Sl #</th>
                          <th>{filter.type === "tasks" ? "Completed On" : "Job Date"}</th>
                          <th>{filter.type === "tasks" ? "Task" : "Job"}</th>
                          {filter.type !== "tasks" && <th>Job Category</th>}
                          <th>Username</th>
                          <th>Evidence</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.records.length === 0 && (
                          <tr>
                            <td colSpan={filter.type !== "tasks" ? 6 : 5}>
                              <Alert variant="danger" className="text-center p-5">
                                No evidences found!
                              </Alert>
                            </td>
                          </tr>
                        )}
                        {data.records.map((d, idx) => {
                          let evidences = [];
                          try {
                            if (filter.type === "tasks") {
                              evidences = Array.isArray(d.evidence) ? d.evidence : [d.evidence];
                            } else {
                              evidences = typeof d.evidence === "string" ? JSON.parse(d.evidence) : (Array.isArray(d.evidence) ? d.evidence : [d.evidence]);
                            }
                          } catch (e) {
                            evidences = d.evidence ? [d.evidence] : [];
                          }
                          if (!Array.isArray(evidences)) evidences = [evidences];
                          evidences = evidences.filter(Boolean);

                          const formattedJobName = typeof d.job_name === "string" && (d.job_name.startsWith('"') || d.job_name.startsWith('['))
                            ? d.job_name.replace(/^[\["']+|[\]"']+$/g, '')
                            : (d.job_name || "");

                          return (
                            <tr key={d.id}>
                              <td>
                                <div className={`tb-lable tb-lable-success text-center`}>{Utils.addZero(getRecordStart(idx))}</div>
                              </td>
                              <td className="align-middle">{filter.type === "tasks" ? Utils.toLocal(d.completed_on).format("YYYY-MM-DD HH:mm:ss") : d.job_date}</td>
                              <td className="align-middle" style={{ whiteSpace: "pre-wrap" }}>
                                {filter.type === "tasks" ? d.task_name : formattedJobName}
                              </td>
                              {filter.type !== "tasks" && <td className="align-middle">{d.cat_name}</td>}
                              <td className="align-middle">{d.uname}</td>
                              <td className="align-middle">
                                <Button
                                  onClick={() =>
                                    setShowEvidences({
                                      id: d.id,
                                      evidences: evidences,
                                    })
                                  }
                                >
                                  View ({evidences.length})
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                    <div className="d-flex flex-row-reverse">
                      {pageSelect()}
                      {showPagination(data)}
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {_.get(showEvidences, "evidences", []).length > 0 && (
          <EvidenceList data={showEvidences} type={filter.type} onHide={() => setShowEvidences({})} />
        )}
      </div>
    </React.Fragment>
  );
};

export default Evidences;
